export default __webpack_public_path__ + "static/media/Synthetics.bbac4b98.png";